import { DateTime } from 'luxon-business-days';
// eslint-disable-next-line import/no-extraneous-dependencies
import { faker } from '@faker-js/faker';

const now = DateTime.local();
const nextMonth = now.plusBusiness({ days: 30 });

const generateCampaignCode = () => `${faker.string.numeric(4)}`;
const campaignCode = generateCampaignCode();
const addressState = faker.location.state({ abbreviated: true });

const generateStreetAddress2 = () => {
  const beRandom = faker.string.numeric(1);
  if (beRandom % 2 === 0) {
    return '';
  }
  return `Apt. ${faker.string.numeric(2)}`;
};

const initialState = {
  campaign: {
    name: faker.company.name(),
    printExpireDate: nextMonth.toFormat('yyyy-MM-dd'),
    activeDate: now.toFormat('yyyy-MM-dd'),
    mailedDate: now.toFormat('yyyy-MM-dd'),
    externalCampaignId: '',
    leadProviderId: '',
    campaignCode,
    maxLoanAmount: faker.string.numeric(4),
  },

  prospect: {
    firstName: faker.person.firstName(),
    middleInitial: faker.person.middleName().slice(1, 2),
    lastName: faker.person.lastName(),
    systemExpireDate: nextMonth.toFormat('yyyy-MM-dd'),
    ssn7: faker.string.numeric(7),
    suffix: faker.person.fullName().slice(1, 2),
    streetAddress: faker.location.streetAddress(),
    streetAddress2: generateStreetAddress2(),
    city: faker.location.city(),
    state: addressState,
    zip: faker.location.zipCode('#####'),
    offerCode: `${faker.string.numeric(4)}-${faker.string.numeric(4)}-${campaignCode}`,
    clarityKey: faker.string.numeric(17),
    programName: faker.string.numeric(10),
    householdNumber: faker.string.numeric(10),
    clearCreditScore: faker.string.numeric(3),
    vantageV4Score: faker.string.numeric(3),
    riskScore: faker.string.numeric(3),
    prescreenFileId: faker.string.numeric(),
    numTimesCodeSubmitted: 0,
    isWalkupComplete: 0,
    isTransUnion: false,
  },
};

const getters = {
  campaign: (state) => state.campaign,
  prospect: (state) => state.prospect,
};

const actions = {
  refreshData({ commit }) {
    commit('REFRESH_DATA');
  },
  setCampaignData({ commit }, data) {
    commit('SET_CAMPAIGN_DATA', data);
  },
  updateCampaignData({ commit }, data) {
    commit('UPDATE_CAMPAIGN_DATA', data);
  },

  setProspectData({ commit }, data) {
    commit('SET_PROSPECT_DATA', data);
  },
  updateProspectData({ commit }, data) {
    commit('UPDATE_PROSPECT_DATA', data);
  },
};

const mutations = {
  REFRESH_DATA(state) {
    const generateStreetAddressTwo = () => {
      const beRandom = faker.string.numeric(1);
      if (beRandom % 2 === 0) {
        return '';
      }
      return `Apt. ${faker.string.numeric(2)}`;
    };

    state.campaign = {
      name: faker.company.name(),
      printExpireDate: nextMonth.toFormat('yyyy-MM-dd'),
      activeDate: DateTime.local().toFormat('yyyy-MM-dd'),
      mailedDate: DateTime.local().toFormat('yyyy-MM-dd'),
      externalCampaignId: '',
      leadProviderId: '',
      campaignCode: `${faker.string.numeric(4)}`,
      maxLoanAmount: faker.string.numeric(4),
    };

    state.prospect = {
      firstName: faker.person.firstName(),
      middleInitial: faker.person.middleName().slice(1, 2),
      lastName: faker.person.lastName(),
      ssn7: faker.string.numeric(7),
      suffix: faker.person.fullName().slice(1, 2),
      streetAddress: faker.location.streetAddress(),
      streetAddress2: generateStreetAddressTwo(),
      city: faker.location.city(),
      state: faker.location.state({ abbreviated: true }),
      zip: faker.location.zipCode('#####'),
      offerCode: `${faker.string.numeric(4)}-${faker.string.numeric(4)}-${state.campaign.campaignCode}`,
      clarityKey: faker.string.numeric(17),
      programName: faker.string.numeric(10),
      householdNumber: faker.string.numeric(10),
      clearCreditScore: faker.string.numeric(3),
      vantageV4Score: faker.string.numeric(3),
      riskScore: faker.string.numeric(3),
      prescreenFileId: faker.string.numeric(),
      numTimesCodeSubmitted: 0,
      systemExpireDate: nextMonth.toFormat('yyyy-MM-dd'),
      isWalkupComplete: 0,
    };
  },
  SET_CAMPAIGN_DATA(state, data) {
    state.campaign = data;
  },
  UPDATE_CAMPAIGN_DATA(state, data) {
    Object.keys(data).forEach((key) => {
      state.campaign[key] = data[key];
    });
  },

  SET_PROSPECT_DATA(state, data) {
    state.prospect = data;
  },
  UPDATE_PROSPECT_DATA(state, data) {
    Object.keys(data).forEach((key) => {
      state.prospect[key] = data[key];
    });
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
